// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1tYXy","title":"BackImages_title__2EVn1","images":"BackImages_images__3H4qt"};